export const prepareSeverityByStatus = (status) => {
    switch (status) {
        case "fraud":
            return {
                severity: "3",
                family: "error",
            };
        case "to-be-validated":
            return {
                severity: "1",
                family: "warning",
            };
        case "compliant":
            return {
                severity: "0",
                family: "success",
            };
        default:
            return {};
    }
};
